var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcPwOff = function SvgIcPwOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.615 8.357a.75.75 0 0 1 1.028.258C6.145 11.12 8.877 12.8 12 12.8c3.124 0 5.855-1.68 7.357-4.185a.75.75 0 1 1 1.286.77 10.175 10.175 0 0 1-2.377 2.72l.79 1.19a.75.75 0 1 1-1.251.83l-.777-1.174a9.994 9.994 0 0 1-2.315.978l.271 1.309a.75.75 0 1 1-1.468.305l-.274-1.32a10.12 10.12 0 0 1-2.523-.004l-.241 1.298a.75.75 0 1 1-1.475-.274l.247-1.325a9.998 9.998 0 0 1-2.315-.989l-.73 1.16a.75.75 0 1 1-1.27-.799l.765-1.213a10.176 10.176 0 0 1-2.343-2.691.75.75 0 0 1 .258-1.03Z"
  })));
};
export default SvgIcPwOff;